// @flow
import * as React from 'react';
import { localize } from '@ta/common.i18n';
import { ConfirmationPopover, type Props as ConfirmationProps } from '@ta/social.common-popover';

// Types for these don't actually matter, only name needs to be specified
type UsedProps = {|
  header: any,
  description: any,
  cancel: any,
  confirm: any,
  onCancel: any,
  onConfirm: any,
|};

type PopoverProps = $Diff<ConfirmationProps, UsedProps>;

type Props = {|
  objectType: string,
  deleteObject: ?() => void,
  ...PopoverProps,
|};

const localizationKeys = {
  /* Are you sure you want to delete this review? The review can not be retrieved once it is deleted. */
  Review: () => localize('delete_confirmation_description_review_0'),
  /* Are you sure you want to delete this photo? The photo can not be retrieved once it is deleted. */
  Photo: () => localize('delete_confirmation_description_photo_0'),
  /* Are you sure you want to delete this video? The video can not be retrieved once it is deleted. */
  Video: () => localize('delete_confirmation_description_video_0'),
  /* Are you sure you want to delete this forum post? The forum post can not be retrieved once it is deleted. */
  ForumPost: () => localize('delete_confirmation_description_forum_post_0'),
  /* Are you sure you want to delete this link? The link can not be retrieved once it is deleted. */
  LinkPost: () => localize('delete_confirmation_description_link_post_0'),
  /* Are you sure you want to delete this Trip? Deleting a Trip will delete all the items and notes you have added to it. The Trip cannot be retrieved once it is deleted. */
  Trip: () => localize('trips_delete_trip_confirmation_text_v2'),
  /* Are you sure you want to delete this repost? The repost can not be retrieved once it is deleted. */
  Repost: () => localize('delete_confirmation_description_repost_0'),
  /* Are you sure you want to delete this question? */
  ApiLocationTopic: () => localize('aao_delete_question_msg_fffff375'),
  /* Are you sure you want to delete this answer? */
  ApiTopicPosting: () => localize('aao_delete_answer_msg_fffff375'),
  /* 	Are you sure you want to delete this post? The post can not be retrieved once it is deleted.  */
  MediaBatch: () => localize('delete_confirmation_description_post_0'),
};

const localizationHeaderKeys = {
  Review: () => localize('delete_confirmation_header_review_0' /* Delete review? */),
  Photo: () => localize('delete_confirmation_header_photo_0' /* Delete photo? */),
  Video: () => localize('delete_confirmation_header_video_0' /* Delete video? */),
  ForumPost: () => localize('delete_confirmation_header_forum_post_0' /* Delete forum post? */),
  LinkPost: () => localize('delete_confirmation_header_link_post_0' /* Delete link? */),
  Repost: () => localize('delete_confirmation_header_repost_1' /* Delete repost? */),
  Trip: () => localize('trips_delete_trip_confirmation_header' /* Delete Trip? */),
  MediaBatch: () => localize('delete_confirmation_header_post_0' /* Delete post? */),
};

const cancel = () => localize('aao_delete_cancel_btn_fffff375'); /* Cancel */
const confirm = () => localize('inbox_swipe_delete'); /* Delete */

const DeleteConfirmation = ({ objectType, deleteObject, ...confirmationProps }: Props) => (
  <ConfirmationPopover
    {...confirmationProps}
    header={localizationHeaderKeys[objectType]}
    description={localizationKeys[objectType]}
    cancel={cancel}
    confirm={confirm}
    onConfirm={deleteObject}
    onCancel={null}
  />
);

DeleteConfirmation.defaultProps = {
  above: undefined,
  below: undefined,
  rightOf: undefined,
  leftOf: undefined,
  alignEdge: undefined,
  shiftX: 0,
  shiftY: 0,
  shiftArrow: 0,
  fixed: false,
  deleteObject: null,
};

export default DeleteConfirmation;
